export default "__VITE_ASSET__DSGu19hB__"